<template>
  <div class="layout-px-spacing">
    <teleport to="#breadcrumb">
      <ul class="navbar-nav flex-row">
        <li>
          <div class="page-header">
            <nav class="breadcrumb-one" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page">
                  <span>Add Violation Action</span>
                </li>
              </ol>
            </nav>
          </div>
        </li>
      </ul>
    </teleport>

    <div class="row layout-top-spacing">
      <div class="col-xl-12">
        <div class="panel br-4">
          <div class="panel-body">
            <h3>Create Violation Action!</h3>
            <form @submit.prevent="submitReport">
              <!-- Violation Select -->
              <div class="form-group">
                <label for="violation">Select Violation</label>
                <!-- <multiselect v-model="violationAction.violation_id" :options="filteredViolations" :searchable="true"
                  :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                  placeholder="Select a Violation" label="title" track-by="id">
                </multiselect> -->
                <select v-model="violationAction.violation_id" class="form-control" id="violation">
                  <option value="">Select a Violation</option>
                  <option v-for="violation in filteredViolations" :key="violation.id" :value="violation.id">
                    {{ violation.title }}
                  </option>
                </select>
              </div>

              <!-- Main Form Fields -->
              <div class="row mt-3">
                <!-- Left -->
                <div class="col-md-6">
                  <div class="form-group mt-3">
                    <label for="employee">Select Driver</label>
                    <multiselect v-model="violationAction.driver_id" :options="filteredDrivers" :searchable="true"
                      :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select a Driver" label="name" track-by="id">
                    </multiselect>
                  </div>

                  <div class="form-group mt-3">
                    <label for="employee">Select Conductor</label>
                    <!-- <multiselect v-model="violationAction.conductor_id" :options="filteredConductors" :searchable="true"
                      :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select a Conductor" label="driver" track-by="employee_id">
                    </multiselect> -->
                    <input type="text" class="form-control" v-model="violationAction.conductor_id" id="conductor"
                      placeholder="Enter Conductor Name">
                  </div>

                  <div class="form-group mt-3">
                    <label for="truck">Bus</label>
                    <multiselect v-model="violationAction.registration" :options="filteredBuses" :searchable="true"
                      :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select a Bus" label="registration" track-by="id">
                    </multiselect>
                  </div>

                  <!-- Time -->
                  <!-- <div class="form-group mt-3">
                    <label for="Time">Time</label>
                    <input type="time" class="form-control" v-model="violationAction.time" id="Time">
                  </div> -->

                  <!-- Location -->
                  <!-- <div class="form-group mt-3">
                    <label for="location">Location</label>
                    <input type="text" class="form-control" v-model="violationAction.location" id="location">
                  </div> -->
                </div>

                <!-- Right -->
                <div class="col-md-6">
                  <div class="form-group mt-3">
                    <label for="route">Schedule</label>
                    <!-- <multiselect v-model="violationAction.loading_order_item_id" :options="filteredLoadingOrders"
                      :searchable="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select a Route" :custom-label="loadingOrderLabel" track-by="id" /> -->
                    <input type="text" class="form-control" v-model="violationAction.schedule" id="schedule"
                      placeholder="Departure Time and Date">
                  </div>

                  <div class="form-group mt-3">
                    <label for="route">Route</label>
                    <!-- <multiselect v-model="violationAction.loading_order_item_id" :options="filteredLoadingOrders"
                      :searchable="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select a Route" :custom-label="loadingOrderLabel" track-by="id" /> -->
                    <input type="text" class="form-control" v-model="violationAction.route" id="route"
                      placeholder="Enter Route">
                  </div>

                  <!-- <div class="form-group mt-3">
                    <label for="schedule">Schedule</label>
                    <multiselect v-model="violationAction.schedule" :options="filteredSchedules" :searchable="true"
                      :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                      placeholder="Select a Schedule" label="scheduleLabel" track-by="id"
                      @select="updateScheduleDetails">
                      <template slot="option" slot-scope="props">
                        <div class="schedule-option">
                          <div><strong>{{ props.option.route }}</strong></div>
                          <div>Date: {{ formatDate(props.option.departure_date) }}</div>
                          <div>Time: {{ props.option.departure_time }}</div>
                          <div>Bus: {{ props.option.vehicle_registration }}</div>
                        </div>
                      </template>
</multiselect>
</div> -->

                  <div v-if="parameters.length" class="row">
                    <div v-for="param in parameters" :key="param.id" class="col-md-6 mt-3">
                      <label :for="'param-' + param.id">{{ param.name }}</label>

                      <!-- Text Input -->
                      <input v-if="param.datatype === 'text'" type="text" class="form-control"
                        v-model="violationAction.parameters[param.name]" :id="'param-' + param.id">

                      <!-- Number Input -->
                      <input v-else-if="param.datatype === 'number'" type="number" class="form-control"
                        v-model.number="violationAction.parameters[param.name]" :id="'param-' + param.id">

                      <!-- Date-Time Input -->
                      <input v-else-if="param.datatype === 'datetime-local'" type="datetime-local" class="form-control"
                        v-model="violationAction.parameters[param.name]" :id="'param-' + param.id">

                      <!-- Time Input -->
                      <input v-else-if="param.datatype === 'time'" type="time" class="form-control"
                        v-model="violationAction.parameters[param.name]" :id="'param-' + param.id">

                      <!-- Default to text if unknown type -->
                      <input v-else type="text" class="form-control" v-model="violationAction.parameters[param.name]"
                        :id="'param-' + param.id">
                    </div>
                  </div>
                </div>
              </div>

              <!-- Submit -->
              <div class="text-center mt-3">
                <div v-if="loading">
                  <button type="button" class="btn btn-success btn-lg mb-3 me-3"><span
                      class="spinner-grow text-white me-2 align-self-center loader-sm">Loading...</span>
                    Processing
                  </button>
                </div>
                <div v-else>
                  <button type="submit" class="btn btn-success btn-lg mb-3 me-3">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import axios from 'axios';
import { BASE_URL, BASE_URL_3 } from '@/Config/config';
import { BASE_URL_4 } from '@/Config/config4';
import { useMeta } from '@/composables/use-meta';
import Swal from 'sweetalert2';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { useStore } from 'vuex';

useMeta({ title: 'Add Violation Action' });

const store = useStore();

const loading = ref(false);

const drivers = ref([]);
const conductors = ref([]);
const violations = ref([]);
const parameters = ref([]);
const buses = ref([]);
const violationSearch = ref('');
const driverSearch = ref('');
const conductorSearch = ref('');
const busSearch = ref('');
// const actionsTakenList = ref([]);
// const actionsTakenSearch = ref('');
const schedules = ref([]);
const scheduleSearch = ref('');

const driverLabel = (option) => `${option.driver}`;

const violationAction = ref({
  violation_id: '',
  driver_id: '',
  conductor_id: '',
  registration: '',
  route: '',
  schedule: '',
  // taken_action_id: null,
  parameters: {}
});

// SweetAlert functions
const showSuccessAlert = (message) => {
  Swal.fire({
    icon: 'success',
    title: 'Success!',
    text: message,
    padding: '2em',
    timer: 3000,
    timerProgressBar: true,
    showConfirmButton: false
  });
};

const showErrorAlert = (message) => {
  Swal.fire({
    icon: 'error',
    title: 'Error!',
    text: message,
    padding: '2em',
    confirmButtonColor: '#3085d6',
    confirmButtonText: 'OK'
  });
};

const filteredViolations = computed(() => {
  if (!violationSearch.value) return violations.value;
  const term = violationSearch.value.toLowerCase();
  return violations.value.filter(violation =>
    violation.title.toLowerCase().includes(term))
});

const filteredDrivers = computed(() => {
  if (!driverSearch.value) return drivers.value;
  const term = driverSearch.value.toLowerCase();
  return drivers.value.filter(driver =>
    driver.name.toLowerCase().includes(term))
});

const filteredBuses = computed(() => {
  if (!busSearch.value) return buses.value;
  const term = busSearch.value.toLowerCase();
  return buses.value.filter(bus =>
    bus.registration.toLowerCase().includes(term))
});

const filteredSchedules = computed(() => {
  if (!scheduleSearch.value) return schedules.value;
  const term = scheduleSearch.value.toLowerCase();
  return schedules.value.filter(schedule =>
    schedule.route.toLowerCase().includes(term) ||
    schedule.departure_date.toLowerCase().includes(term) ||
    schedule.departure_time.toLowerCase().includes(term) ||
    schedule.vehicle_registration.toLowerCase().includes(term)
  );
});

const loadSchedules = async () => {
  try {
    const response = await axios.get(`${BASE_URL_4}/schedules/trips`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    });

    schedules.value = response.data.map(schedule => ({
      id: schedule.id,
      departure_date: schedule.departure_date,
      departure_time: schedule.departure_time,
      route: `${schedule.route.city_from.name} - ${schedule.route.city_to.name}`,
      vehicle_registration: schedule.new_loading_order_vehicles[0]?.vehicle?.registration_number || 'N/A',
      rawData: schedule
    }));

    console.log('Schedules loaded:', schedules.value);
  } catch (error) {
    console.error('Error loading schedules:', error);
    showErrorAlert('Failed to load schedules. Please try again later.');
  }
};

const updateScheduleDetails = (selectedSchedule) => {
  if (selectedSchedule) {
    // Update related fields when a schedule is selected
    violationAction.value.route = selectedSchedule.route;
    violationAction.value.departure_date = selectedSchedule.departure_date;
    violationAction.value.departure_time = selectedSchedule.departure_time;

    // If you want to auto-select the bus as well
    if (selectedSchedule.vehicle_registration && selectedSchedule.vehicle_registration !== 'N/A') {
      const matchingBus = buses.value.find(bus =>
        bus.registration === selectedSchedule.vehicle_registration
      );
      if (matchingBus) {
        violationAction.value.registration = matchingBus;
      }
    }
  }
};

// Add scheduleLabel computed property to multiselect options
const scheduleLabel = (option) => {
  return `${option.route} - ${formatDate(option.departure_date)} ${option.departure_time}`;
};

const loadViolations = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/violations`, {
      headers: {
        'Authorization': `Bearer ${store.state.token}`,
        'X-Company-ID': store.state.currentCompany?.id
      }
    });
    violations.value = response.data.data || response.data;
    console.log('Violations loaded:', violations.value);
  } catch (error) {
    console.error('Error loading violations:', error);
    showErrorAlert('Failed to load violations. Please try again later.');
  }
};

const loadDrivers = async () => {
  try {
    const response = await axios.get(`${BASE_URL_3}/company/employees/list?company_id=2`);
    drivers.value = response.data.employees || response.data;
    console.log("Drivers loaded:", drivers.value);
  } catch (error) {
    console.error('Error fetching employees:', error);
    showErrorAlert('Failed to load drivers. Please try again later.');
  }
};

const loadBuses = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/navirec/vehicles`);
    const rawBuses = response.data.data || response.data;

    // Transform the data to only include id and registration
    buses.value = rawBuses.map(bus => ({
      id: bus.id,
      registration: bus.registration
    }));
    console.log("Buses loaded:", buses.value);
  } catch (error) {
    console.error('Error fetching Buses:', error);
    showErrorAlert('Failed to load Buses. Please try again later.');
  }
};

const fetchActionsTaken = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/taken-actions`, {
      headers: {
        'Authorization': `Bearer ${store.state.token}`,
        'X-Company-ID': store.state.currentCompany?.id
      }
    });
    actionsTakenList.value = response.data.data || response.data;
    console.log('Actions taken loaded:', actionsTakenList.value);
  } catch (error) {
    console.error('Error fetching actions taken:', error);
    showErrorAlert('Failed to load actions taken. Please try again later.');
  }
};

watch(() => violationAction.value.violation_id, async (newVal) => {
  const violationId = newVal?.id || newVal;
  if (violationId) {
    try {
      const response = await axios.get(`${BASE_URL}/violations/${violationId}`, {
        headers: {
          'Authorization': `Bearer ${store.state.token}`,
          'X-Company-ID': store.state.currentCompany?.id
        }
      });
      const violationData = response.data;

      parameters.value = violationData.parameters || [];
      violationAction.value.parameters = {};

      parameters.value.forEach(param => {
        violationAction.value.parameters[param.name] = '';
      });

      console.log('Parameters loaded:', parameters.value);
    } catch (error) {
      console.error('Error loading violation parameters:', error);
      parameters.value = [];
      violationAction.value.parameters = {};
      showErrorAlert('Failed to load parameters for this violation');
    }
  } else {
    parameters.value = [];
    violationAction.value.parameters = {};
  }
}, { immediate: true });

const submitReport = async () => {
  try {
    loading.value = true;

    // Prepare the payload with string IDs
    const payload = {
      ...violationAction.value,
      driver_id: typeof violationAction.value.driver_id === 'object'
        ? violationAction.value.driver_id.id.toString()
        : violationAction.value.driver_id.toString() || '',
      conductor_id: violationAction.value.conductor_id,
      violation_id: typeof violationAction.value.violation_id === 'object'
        ? violationAction.value.violation_id.id
        : violationAction.value.violation_id,
      route: violationAction.value.route, // This now contains "DAR ES SALAAM - ARUSHA"
      // schedule: violationAction.value.schedule ?
      //   `${violationAction.value.schedule.departure_date} ${violationAction.value.schedule.departure_time}` :
      //   '',
      schedule: violationAction.value.schedule,
      bus_registration: typeof violationAction.value.registration === 'object'
        ? violationAction.value.registration.registration
        : violationAction.value.registration,
      // taken_action_id: violationAction.value.taken_action_id || null,
      parameters: violationAction.value.parameters
    };

    console.log("Payload to be sent:", payload);

    // Uncomment the following line to send the payload to the server

    const response = await axios.post(`${BASE_URL}/abs-violation-actions/store`,
      payload,
      {
        headers: {
          'Authorization': `Bearer ${store.state.token}`,
          'X-Company-ID': store.state.currentCompany?.id
        }
      });

    if (response.data.success) {
      showSuccessAlert("Violation Action submitted successfully!");

      // Reset form
      violationAction.value = {
        violation_id: '',
        driver_id: '',
        conductor_id: '',
        route: '',
        schedule: null,
        // taken_action_id: '',
        bus_registration: '',
        parameters: {}
      };

      // Reset search fields
      driverSearch.value = '';
      busSearch.value = '';
      conductorSearch.value = '';
      scheduleSearch.value = '';
    } else {
      showErrorAlert(response.data.message || "Error submitting report");
    }
  } catch (error) {
    console.error("Submission error:", error);

    let errorMessage = "Failed to submit violation action";
    if (error.response) {
      if (error.response.data?.errors) {
        errorMessage = Object.entries(error.response.data.errors)
          .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
          .join('\n');
      } else if (error.response.data?.message) {
        errorMessage = error.response.data.message;
      }
    } else if (error.request) {
      errorMessage = "Network error - please check your connection";
    }

    showErrorAlert(errorMessage);
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  loading.value = true;
  try {
    // Load initial data
    await Promise.all([
      loadViolations(),
      loadDrivers(),
      loadBuses(),
      // fetchActionsTaken(),
      // loadSchedules(), // Uncomment if you want to load schedules on mount
    ]);
  } catch (error) {
    console.error('Error loading initial data:', error);
    showErrorAlert('Failed to load initial data. Please try again later.');
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.layout-px-spacing {
  min-height: calc(100vh - 170px) !important;
}

.schedule-option {
  padding: 8px;
  line-height: 1.4;
}

.schedule-option div {
  margin-bottom: 2px;
}

.multiselect__option--highlight {
  background: #41b883;
}

.multiselect__option--highlight .schedule-option {
  color: white;
}
</style>
